import { TeamMemberFragmentFragment } from '../../../__generated__/graphql';
import AppImage from '../../../components/AppImage';
import Button from '../../../components/Button';
import ListItemHeading from '../../../components/ListItemHeading';
import { Paragraph } from '../../../components/Text';

import style from './team-member.module.css';

interface TeamMemberProps {
  member: TeamMemberFragmentFragment;
  setSelectedMember: (member: TeamMemberFragmentFragment) => void;
}

const TeamMember = ({
  member,
  setSelectedMember,
}: TeamMemberProps) => {
  const memberJobTitles = (member.jobTitle ?? '').split('\n').map(jt => jt.trim()).filter(Boolean);

  const handleClickBio = () => {
    setSelectedMember(member);
  };

  return (
    <article className={style.article}>
      <div>
        {member.headshot && (
          <AppImage
            className={style.headshot}
            fallbackHeight={400}
            fallbackWidth={400}
            image={member.headshot}
          />
        )}

        {member.name && (
          <ListItemHeading className={style.memberName}>
            {member.name}
          </ListItemHeading>
        )}

        {memberJobTitles.map(jobTitle => (
          <Paragraph key={jobTitle}>
            {jobTitle}
          </Paragraph>
        ))}
      </div>

      <Button
        buttonColor="white"
        className={style.bioCta}
        id={member.ctaId ?? undefined}
        onClick={handleClickBio}
      >
        {member.bioCtaText ?? 'Read Bio'}
      </Button>
    </article>
  );
};

export default TeamMember;
